/**
 * @generated SignedSource<<0ef14c6d147c9b4fff820ba8253f7773>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleActionWidgetArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleCommentsTriggerArticle" | "articlePrintArticle" | "copyLinkArticle20CopyLinkContent">;
  readonly " $fragmentType": "articleActionWidgetArticle";
};
export type articleActionWidgetArticle$key = {
  readonly " $data"?: articleActionWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleActionWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleActionWidgetArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePrintArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "copyLinkArticle20CopyLinkContent"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "16373348c139177f7c99bac423840fcf";

export default node;
